import { Component, input, output } from '@angular/core';
import { SVG_ICONS } from '@shared/constants';

@Component({
    selector: 'app-removable-chip',
    standalone: true,
    imports: [],
    templateUrl: './removable-chip.component.html',
    styleUrl: './removable-chip.component.scss',
})
export class RemovableChipComponent {
    /**
     * Label to display inside the chip
     */
    public label = input.required<string>();

    /**
     * Event emitted when the close/remove button is clicked
     */
    public remove = output<void>();

    /**
     * All available svg icons
     */
    public icons = SVG_ICONS;

    /**
     * Path to the sprite file
     */
    public spritePath = 'assets/icons/icons-sprite.svg';

    /**
     * Handle remove click
     */
    public onRemove(): void {
        this.remove.emit();
    }
}
